import PageHeading from "./PageHeading";
import { Parallax } from "react-scroll-parallax";
import { useState, useContext } from "react";
import "../../../css/azienda.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import useFetch from "../../../hooks/useFetch";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import LanguageContext from "../../../context/language-context";
import useMediaQuery from "react-responsive";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import MidSection from "./MidSection";
import BoxReveal from "../../UI/BoxReveal";
import { Link } from "react-router-dom";
export default function Group() {
  const [counterState, setCounterState] = useState(false);
  const isBigScreen = useMediaQuery({ query: "(min-width: 1100px)" });

  const [expandedItems, setExpandedItems] = useState([]);

  // Function to handle click on list items

  const toggleText2 = (index) => {
    if (expandedItems.includes(index)) {
      setExpandedItems(
        expandedItems.filter((itemIndex) => itemIndex !== index)
      );
    } else {
      setExpandedItems([...expandedItems, index]);
    }
  };
  const translations = {
    en: {
      more: "Read More",
      less: "Read Less",
    },
    fr: {
      more: "Lire Plus",
      less: "Lire Moins",
    },
    de: {
      more: "Mehr Lesen",
      less: "Weniger Lesen",
    },
    ru: {
      more: "Читать далее",
      less: "Читать меньше",
    },
    es: {
      more: "Leer Más",
      less: "Leer Menos",
    },
    it: {
      more: "Leggi di piu ",
      less: "Leggi Meno",
    },
  };
  const languageCtx = useContext(LanguageContext);
  const { loading, error, data } = useFetch(
    `https://spagnoladmin.spagnolcompany.it/api/groups?locale=${languageCtx.languageData}&populate[0]=Video&populate[1]=Mobile_video&populate[2]=Carousel.Image&populate[3]=Middle_Section.Image&populate[4]=Middle_Image&populate[5]=Number_section&populate[6]=Number_section.numbers&populate[7]=Mission&populate[8]=Profile_pdf.PDF&populate[9]=Monograph.PDF`
  );
  if (loading) return <p>Loading...</p>;

  const { data: details, meta } = data;

  return (
    <div className="mg-3">
      <PageHeading
        video={
          isBigScreen
            ? data.data[0].attributes.Video.data.attributes.url
            : data.data[0].attributes.Mobile_video.data.attributes.url
        }
      />
      <div className="mission-text" data-scroll-section>
        <Parallax speed={5}>
          <BoxReveal
            children={
              <BlocksRenderer
                content={details[0].attributes.Mission}
                blocks={{
                  paragraph: ({ children }) => (
                    <p className="mt-4 text-base lg:text-xl">{children}</p>
                  ),
                  heading: ({ children, level }) => {
                    const Tag = `h${level}`;
                    return (
                      <Tag className="mt-4 font-bold text-base lg:text-2xl">
                        {children}
                      </Tag>
                    );
                  },
                  list: ({ children, format }) =>
                    format === "unordered" ? (
                      <ul className="list-disc list-inside ml-6 mt-4">
                        {children}
                      </ul>
                    ) : (
                      <ol className="list-decimal list-inside ml-6 mt-4">
                        {children}
                      </ol>
                    ),
                  quote: ({ children }) => (
                    <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                      {children}
                    </blockquote>
                  ),
                  link: ({ children, url }) => (
                    <Link to={url} className="text-footer underline">
                      {children}
                    </Link>
                  ),
                }}
              />
            }
            boxColor="#fff"
          />
        </Parallax>
      </div>

      <div className="first-section">
        <div
          className="section-inner group
        "
        >
          <div className="right-text curve">
            <Parallax speed={5}>
              <div className="hovereffect">
                <a className="test curve">
                  <img
                    src={`https://spagnoladmin.spagnolcompany.it${details[0].attributes.Middle_Section.Image.data.attributes.url}`}
                  />
                </a>
              </div>
            </Parallax>
          </div>
          <div className="left-text two">
            <Parallax speed={5}>
              <>
                <BlocksRenderer
                  content={details[0].attributes.Middle_Section.Text}
                  blocks={{
                    paragraph: ({ children }) => (
                      <p className="mt-4 text-base lg:text-xl">{children}</p>
                    ),
                    heading: ({ children, level }) => {
                      const Tag = `h${level}`;
                      return (
                        <Tag className="mt-4 font-bold text-base lg:text-2xl">
                          {children}
                        </Tag>
                      );
                    },
                    list: ({ children, format }) =>
                      format === "unordered" ? (
                        <ul className="list-disc list-inside ml-6 mt-4">
                          {children}
                        </ul>
                      ) : (
                        <ol className="list-decimal list-inside ml-6 mt-4">
                          {children}
                        </ol>
                      ),
                    quote: ({ children }) => (
                      <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                        {children}
                      </blockquote>
                    ),
                    link: ({ children, url }) => (
                      <Link to={url} className="text-footer underline">
                        {children}
                      </Link>
                    ),
                  }}
                />
                <br />
                {details[0].attributes.Profile_pdf.ACTIVE && (
                  <a
                    download={
                      details[0].attributes.Profile_pdf.PDF.data.attributes.url
                    }
                    c
                    lassName="underline-hover-effect small-text"
                  >
                    CORPORATE PROFILE
                  </a>
                )}
                <br />
                {details[0].attributes.Monograph.ACTIVE && (
                  <a
                    download={
                      details[0].attributes.Monograph.PDF.data.attributes.url
                    }
                    className="underline-hover-effect small-text"
                  >
                    MONOGRAFIA
                  </a>
                )}
              </>
            </Parallax>
          </div>
        </div>
      </div>

      <div className="first-section bg-color">
        <h3 className="t-large f-medium">i nostri brand</h3>

        <MidSection carousel={data.data[0].attributes.Carousel} />
      </div>
      <section className="bg-grey" data-scroll-section="">
        <div className="maxWidth">
          <div className="is-inview">
            <h3 className="number-bold">
              {details[0].attributes.Number_section.Heading}
            </h3>
          </div>
          <ScrollTrigger
            onEnter={() => setCounterState(true)}
            onExit={() => setCounterState(false)}
          >
            <div className="numeri">
              <div className="two-column">
                {details[0].attributes.Number_section.numbers
                  .slice(0, 4)
                  .map((item, index) => (
                    <div className="is-inview align" key={index}>
                      {index !== 0 && <span className="number-count">+</span>}
                      {counterState && (
                        <CountUp
                          end={item.number}
                          duration={2.75}
                          decimal="."
                          decimals={item.decimals}
                          className="number-count"
                        />
                      )}
                      <label className="suffix">{item.text}</label>
                    </div>
                  ))}
              </div>
              {details[0].attributes.Number_section.numbers
                .slice(4)
                .map((item, index) => {
                  return (
                    <div className="is-inview" key={index}>
                      <span className="number-count">+</span>
                      {counterState && (
                        <CountUp
                          end={item.number}
                          decimal="."
                          decimals={item.decimals}
                          duration={2.75}
                          className="number-count"
                        />
                      )}
                      <label className="suffix">{item.text}</label>
                    </div>
                  );
                })}
            </div>
          </ScrollTrigger>
        </div>
      </section>
      <section className="middle-image" data-scroll-section>
        <div className="mid-img">
          <Parallax speed={0}>
            <div className="hovereffect">
              <a className="test">
                <img
                  src={`https://spagnoladmin.spagnolcompany.it${details[0].attributes.Middle_Image.data.attributes.url}`}
                />
              </a>
            </div>
          </Parallax>
        </div>
      </section>
      <div className="second-text one bg-color-9" data-scroll-section>
        <Parallax speed={5}>
          <BlocksRenderer
            content={data.data[0].attributes.Middle_text}
            blocks={{
              paragraph: ({ children }) => (
                <p className="mt-4 text-base lg:text-xl">{children}</p>
              ),
              heading: ({ children, level }) => {
                const Tag = `h${level}`;
                return (
                  <Tag className="mt-4 font-bold text-base lg:text-2xl">
                    {children}
                  </Tag>
                );
              },
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="list-disc list-inside ml-6 mt-4">
                    {children}
                  </ul>
                ) : (
                  <ol className="list-decimal list-inside ml-6 mt-4">
                    {children}
                  </ol>
                ),
              quote: ({ children }) => (
                <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                  {children}
                </blockquote>
              ),
              link: ({ children, url }) => (
                <Link to={url} className="text-footer underline">
                  {children}
                </Link>
              ),
            }}
          />
        </Parallax>
      </div>
    </div>
  );
}
